import { BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { AuthProvider } from "./hooks/useAuth";
import CookieConsent from "./components/base/CookieConsent";
import AnalyticsScripts from "./components/base/AnalyticsScripts";
import ErrorBoundary from "./components/base/ErrorBoundary";
import { ToastProvider } from "./components/base/Toast";
import { ConfirmProvider } from "./components/base/ConfirmDialog";
import { useSiteSettings } from "./hooks/useSiteSettings";
import i18n from "./i18n";

function AppContent() {
  useSiteSettings();

  useEffect(() => {
    document.documentElement.lang = 'tr';
    document.documentElement.dir = 'ltr';
  }, []);

  return (
    <>
      <AnalyticsScripts />
      <a href="#main-content" className="skip-to-content">Ana içeriğe atla</a>
      <AppRoutes />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ErrorBoundary>
            <ToastProvider>
              <ConfirmProvider>
                <AppContent />
              </ConfirmProvider>
            </ToastProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;